import { css } from '@emotion/react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import React from 'react';

export const TooltipProvider = RadixTooltip.Provider;

interface TooltipPropsBase {
  children: React.ReactNode;
  trigger: React.ReactNode;
  delay?: number;
  contentProps?: RadixTooltip.TooltipContentProps;
}

export type TooltipProps = TooltipPropsBase & RadixTooltip.TooltipTriggerProps;

export const Tooltip = ({
  children,
  trigger,
  delay = 0,
  contentProps = {},
  ...props
}: TooltipProps) => (
  <RadixTooltip.Root delayDuration={delay}>
    <RadixTooltip.Trigger asChild {...props}>
      {trigger}
    </RadixTooltip.Trigger>
    <RadixTooltip.Portal>
      <RadixTooltip.Content
        css={(theme) => css`
          z-index: 10000;
          background: white;
          color: ${theme.midnight};
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 12px;
          line-height: 1.25;
          box-shadow: ${theme.floatingShadow};
          text-align: center;
        `}
        {...contentProps}
      >
        {children}
      </RadixTooltip.Content>
    </RadixTooltip.Portal>
  </RadixTooltip.Root>
);
